/* eslint-disable */
import { Paper } from "@mui/material";
import React from "react";
import styles from "./PaperComponent.module.scss";

export default function PaperComponent({ children, flexible }) {
  const containerClass = flexible
    ? styles["paper-container--flexible"]
    : styles["paper-container"];

  return (
    <Paper elevation={3} className={containerClass}>
      {children}
    </Paper>
  );
}
